<template>
  <div>
    <EmailGrabberPopup
      @close="toggleGrabber"
      :grabberActive="grabberActive"
      :freePlan="freePlan"
      :payPlan="payPlan"
      :planId="planId"
      class="overflow-y-hidden"
    >
    </EmailGrabberPopup>
    <section
      class="mx-[25px] mt-[50px] content-center rounded-[19px] bg-[#2d8bff10] py-10 px-[30px] lg:px-[80px] md:rounded-[60px] lg:mx-auto lg:flex lg:pt-[110px] xl:h-[748px] xl:w-[1300px]"
    >
      <div class="z-20 w-full justify-between py-0 lg:flex">
        <div class="text-left lg:w-[460px]">
          <!-- TABS -->
          <div class="font-bold flex text-[#292d34] text-xs lg:text-lg">
            <div>
              <h3
                class="pr-[45px] cursor-pointer"
                v-on:click="toggleTabs(1)"
                v-bind:class="{
                  'hover:ease-in': openTab !== 1,
                  '': openTab === 1
                }"
              >
                Courses
              </h3>

              <hr
                class="mt-[10px] ml-0 h-[5px] w-[75px] rounded-full bg-[#2D8CFF]"
                v-bind:class="{
                  'hidden ': openTab !== 1,
                  'block ease-in-out duration-700': openTab === 1
                }"
              />
            </div>

            <div>
              <h3
                class="pr-[45px] cursor-pointer"
                v-on:click="toggleTabs(2)"
                v-bind:class="{ '': openTab !== 2, '': openTab === 2 }"
              >
                Chat
              </h3>
              <hr
                class="mt-[10px] ml-0 h-[5px] w-[50px] rounded-full bg-[#2D8CFF]"
                v-bind:class="{
                  'hidden hover:block': openTab !== 2,
                  'block ease-in-out duration-700': openTab === 2
                }"
              />
            </div>

            <div>
              <h3
                class="pr-[45px] cursor-pointer"
                v-on:click="toggleTabs(3)"
                v-bind:class="{ '': openTab !== 3, '': openTab === 3 }"
              >
                Communities
              </h3>
              <hr
                class="mt-[10px] ml-0 h-[5px] w-[125px] rounded-full bg-[#2D8CFF]"
                v-bind:class="{
                  'hidden hover:block': openTab !== 3,
                  'block ease-in-out duration-700': openTab === 3
                }"
              />
            </div>
          </div>
          <h2
            class="headline-1 top-full mt-[45px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            v-bind:class="{
              'hidden ': openTab !== 1,
              'block ease-in-out duration-700': openTab === 1
            }"
          >
            Deliver advanced courses that are worth more.
          </h2>
          <h2
            class="headline-2 top-full mt-[45px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            v-bind:class="{
              'hidden ': openTab !== 2,
              'block ease-in-out duration-700': openTab === 2
            }"
          >
            Bring clients together in chat.
          </h2>
          <h2
            class="headline-3 top-full mt-[45px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            v-bind:class="{
              'hidden ': openTab !== 3,
              'block ease-in-out duration-700': openTab === 3
            }"
          >
            Next level audience engagment.
          </h2>
          <div
            class="demo-1 z-30 mt-[25px] lg:w-[668px] block lg:hidden xl:mt-0"
            v-bind:class="{
              'hidden ': openTab !== 1,
              'block ease-in-out duration-700': openTab === 1
            }"
          >
            <video
              class="lg:w-[650] rounded-[10px] lg:rounded-[20px] shadow-2xl"
              id="member_course_ui_crossshred"
              loop
              muted
              autoplay
              playsinline
            >
              <source
                :src="
                  $filters.media_path(
                    '/videos/fitness-influencer-onlince-course-membership-area-com.mp4'
                  )
                "
                type="video/mp4"
              />
            </video>
          </div>
          <div
            class="demo-2 z-30 mt-[25px] lg:w-[668px] block lg:hidden xl:mt-0"
            v-bind:class="{
              'hidden ': openTab !== 2,
              'block ease-in-out duration-700': openTab === 2
            }"
          >
            <video
              class="lg:w-[650px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
              id="home_video"
              loop
              muted
              autoplay
              playsinline
            >
              <source
                :src="
                  $filters.media_path(
                    '/videos/encrypted-creator-chat-for-subscribers-com.mp4'
                  )
                "
                type="video/mp4"
              />
            </video>
          </div>
          <div
            class="demo-3 z-30 mt-[25px] lg:w-[668px] block lg:hidden xl:mt-0"
            v-bind:class="{
              'hidden ': openTab !== 3,
              'block ease-in-out duration-700': openTab === 3
            }"
          >
            <img
              loading="lazy"
              class="mx-auto lg:w-[645px]"
              :src="
                $filters.media_path(
                  '/images/create-your-own-facebook-group.png'
                )
              "
              alt="Build a socialcommunity on your own domain"
            />
          </div>
          <p
            class="subheadline-1 mt-[32px] mb-10 text-sm font-normal leading-[25px] text-[#7c828d]"
            v-bind:class="{
              'hidden ': openTab !== 1,
              'block ease-in-out duration-700': openTab === 1
            }"
          >
            More than a login with videos. High level ways to leverage your
            initial customer to get more sales on the backend.
          </p>
          <p
            class="subheadline-2 mt-[32px] mb-10 text-sm font-normal leading-[25px] text-[#7c828d]"
            v-bind:class="{
              'hidden ': openTab !== 2,
              'block ease-in-out duration-700': openTab === 2
            }"
          >
            Sell smarter with real time chat from your domain. Direct message,
            leave voice messages, video messages, and upload files to get
            customers results faster and offer more products.
          </p>
          <p
            class="subheadline-3 mt-[32px] mb-10 text-sm font-normal leading-[25px] text-[#7c828d]"
            v-bind:class="{
              'hidden ': openTab !== 3,
              'block ease-in-out duration-700': openTab === 3
            }"
          >
            Create your own community guidelines and forget about following
            someone else’s rules. Host your community on your domain, and build
            an asset you own. Instead of collecting your followers on a big-tech
            stack.
          </p>
          <p
            class="replaces-1 mt-[40px] mb-10 text-[10px] lg:text-sm font-bold leading-[25px] text-[#292d34]"
            v-bind:class="{
              'hidden ': openTab !== 1,
              'block ease-in-out duration-700': openTab === 1
            }"
          >
            REPLACES: Teachable&ensp;|&ensp;Kajabi&ensp;|&ensp;MembersPro
          </p>
          <p
            class="replaces-2 mt-[40px] mb-10 text-[10px] lg:text-sm font-bold leading-[25px] text-[#292d34]"
            v-bind:class="{
              'hidden ': openTab !== 2,
              'block ease-in-out duration-700': openTab === 2
            }"
          >
            REPLACES: Zoom&ensp;|&ensp;WhatsApp&ensp;|&ensp;Google Hangouts
          </p>
          <p
            class="replaces-3 mt-[40px] mb-10 text-[10px] lg:text-sm font-bold leading-[25px] text-[#292d34]"
            v-bind:class="{
              'hidden ': openTab !== 3,
              'block ease-in-out duration-700': openTab === 3
            }"
          >
            REPLACES: Facebook Groups&ensp;|&ensp;Patreon&ensp;|&ensp;Discord
          </p>
          <!-- action -->
          <button
            @click="toggleGrabber('free', null)"
            type="button"
            class="h-[56px] w-[170px] rounded-[9px] bg-[#2d8bff] text-[14px] text-sm font-bold text-white drop-shadow-[0px_10px_25px_#64A7F9] transition ease-in hover:bg-[#0f61c5] active:bg-[#054ca3] dark:border-none"
          >
            Get Started
          </button>
        </div>
        <!-- DESKTOP CARDS -->
        <div
          class="demo-1 z-30 mt-[25px] lg:w-[648px] hidden xl:mt-0"
          v-bind:class="{
            'hidden ': openTab !== 1,
            'lg:block ease-in-out duration-700': openTab === 1
          }"
        >
          <video
            class="lg:w-[650] lg:mt-[30px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
            id="home_video"
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="
                $filters.media_path(
                  '/videos/fitness-influencer-onlince-course-membership-area-com.mp4'
                )
              "
              type="video/mp4"
            />
          </video>
        </div>
        <div
          class="demo-2 z-30 mt-[25px] lg:w-[648px] hidden xl:mt-0"
          v-bind:class="{
            hidden: openTab !== 2,
            'lg:block ease-in-out duration-700': openTab === 2
          }"
        >
          <video
            class="lg:w-[648px] lg:mt-[30px] rounded-[10px] lg:rounded-[20px] shadow-2xl hidden lg:block"
            id="home_video"
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="
                $filters.media_path(
                  '/videos/encrypted-creator-chat-for-subscribers-com.mp4'
                )
              "
              type="video/mp4"
            />
          </video>
        </div>
        <div
          class="demo-3 z-30 mt-[25px] lg:w-[648px] hidden xl:mt-0"
          v-bind:class="{
            'hidden ': openTab !== 3,
            'lg:block ease-in-out duration-700': openTab === 3
          }"
        >
          <img
            loading="lazy"
            class="mx-auto lg:w-[645px] lg:mt-[30px]"
            :src="
              $filters.media_path('/images/create-your-own-facebook-group.png')
            "
            alt="Build a socialcommunity on your own domain"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'blue-sectio'
};
</script>

<script setup>
import { ref } from 'vue';
import EmailGrabberPopup from '../Components/EmailGrabberPopup.vue';

const openTab = ref(1);
const grabberActive = ref(false);
const freePlan = ref(false);
const payPlan = ref(false);
const planId = ref(null);

const toggleTabs = (tabNumber) => {
  openTab.value = tabNumber;
};

const toggleGrabber = (plan, id) => {
  if (plan === 'free') {
    freePlan.value = true;
    payPlan.value = false;
    planId.value = null;
  }
  if (plan === 'pay') {
    payPlan.value = true;
    planId.value = id;
    freePlan.value = false;
  }
  grabberActive.value = !grabberActive.value;
};
</script>

<styles>
</styles>
